/**
 * Default avatar fallbacks for chat messages.
 *
 * Used when config does not provide bot_avatar_url / user_avatar_url.
 * Variants can also override these defaults by reassigning via
 * setDefaultBotAvatar / setDefaultUserAvatar.
 */

export const DEFAULT_BOT_AVATAR_SVG = `<svg viewBox="0 0 32 32" width="100%" height="100%" fill="currentColor" aria-hidden="true">
  <circle cx="16" cy="16" r="16" fill="#E9E5DD"/>
  <path d="M10 13a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4l-3 3v-3a3 3 0 0 1-2-3v-4z" fill="#8C7B5A"/>
  <circle cx="14" cy="15" r="1.2" fill="#fff"/>
  <circle cx="18" cy="15" r="1.2" fill="#fff"/>
</svg>`;

export const DEFAULT_USER_AVATAR_SVG = `<svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" id="user" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path id="primary" d="M21,20a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2,6,6,0,0,1,6-6h6A6,6,0,0,1,21,20Zm-9-8A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z" style="fill: rgb(0, 0, 0);"></path></svg>`;

let _defaultBot = DEFAULT_BOT_AVATAR_SVG;
let _defaultUser = DEFAULT_USER_AVATAR_SVG;

export function getDefaultBotAvatar() {
  return _defaultBot;
}

export function getDefaultUserAvatar() {
  return _defaultUser;
}

export function setDefaultBotAvatar(svg) {
  _defaultBot = svg;
}

export function setDefaultUserAvatar(svg) {
  _defaultUser = svg;
}
